import React from 'react';
import { I18n } from '@aws-amplify/core';
import { CloseOutlined } from '@ant-design/icons';
import { Typography, Row, Col } from 'antd';

import { VideoPlayer } from '../VideoPlayer';
import { formatVideoInfoUploadDate } from '@/components/views/Report/KimLhc/utils/helper';

import * as S from './styles';

const { Title } = Typography;

interface VideoInfo {
	original_name?: string;
	generated_name?: string;
	upload_date?: string;
	upload_author_id?: string;
	upload_author_name?: string;
}

interface VideoDrawerProps {
	open?: boolean;
	onClose: () => void;
	videoUrl?: string;
	videoInfo?: VideoInfo;
}

export function VideoDrawer({ open = false, onClose, videoUrl, videoInfo }: Readonly<VideoDrawerProps>) {
	const videoInfoUploadDate = formatVideoInfoUploadDate(videoInfo?.upload_date);

	return (
		<S.StyledDrawer
			title={
				<div>
					<Title level={3} style={{ margin: 0 }}>
						{I18n.get('Video')}
					</Title>
					<CloseOutlined className="close-icon" onClick={onClose} />
				</div>
			}
			placement="right"
			closable={false}
			onClose={onClose}
			open={open}
			width={500}
			footer={
				<Row justify="center">
					<Col>
						<S.CloseButton onClick={onClose}>{I18n.get('Close')}</S.CloseButton>
					</Col>
				</Row>
			}
		>
			<S.VideoContainer>
				<S.VideoPlayerWrapper>
					<VideoPlayer src={videoUrl} title={videoInfo?.original_name} />
				</S.VideoPlayerWrapper>
				<S.InfoSection>
					{videoInfo?.original_name && (
						<S.InfoItem>
							<S.InfoLabel>{I18n.get('File')}</S.InfoLabel>
							<S.InfoValue>{videoInfo.original_name}</S.InfoValue>
						</S.InfoItem>
					)}
					{videoInfoUploadDate && (
						<S.InfoItem>
							<S.InfoLabel>{I18n.get('Upload date')}</S.InfoLabel>
							<S.InfoValue>{videoInfoUploadDate}</S.InfoValue>
						</S.InfoItem>
					)}
				</S.InfoSection>
			</S.VideoContainer>
		</S.StyledDrawer>
	);
}
